import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    salesstatistics: [], // 先放空数组，类型随意
  },
  mutations: {
    // 专门用来接收并写入销售统计
    SET_SALES_STATISTICS(state, payload) {
      state.salesstatistics = payload;
    },
  },
  getters: {
    salesstatistics: (state) => state.salesstatistics,
  },
  actions: {},
  modules: {},
});
